import React from "react";
import { useTranslation } from "react-i18next";

const AdminCard = ({ title, onClick, icon, description }) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language.startsWith('ar');
    return (
        <div
            onClick={onClick}
            className="group bg-white border border-gray-100 rounded-3xl p-6 cursor-pointer hover:shadow-2xl hover:shadow-brand-primary/10 hover:border-brand-primary/20 transition-all duration-300 relative overflow-hidden"
        >
            <div className="absolute top-0 right-0 w-24 h-24 bg-brand-primary/5 rounded-bl-[60px] -mr-4 -mt-4 transition-transform group-hover:scale-110"></div>

            <div className="relative z-10 flex items-start gap-4">
                <div className="w-12 h-12 bg-indigo-50 rounded-2xl flex items-center justify-center text-2xl group-hover:scale-110 transition-transform duration-300">
                    {icon}
                </div>
                <div>
                    <h3 className="text-lg font-black text-gray-900 mb-1 group-hover:text-brand-primary transition-colors">{title}</h3>
                    {description && <p className="text-xs font-medium text-gray-400 leading-relaxed">{description}</p>}
                </div>
            </div>

            <div className={
                isArabic
                    ? "absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-4 group-hover:translate-x-0"
                    : "absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-4 group-hover:translate-x-0"
            }>

                {isArabic ? <i className="fas fa-arrow-left text-brand-primary"></i> : <i className="fas fa-arrow-right text-brand-primary"></i>}
            </div>
        </div>
    );
};

export default AdminCard;
